import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

export const setSelectedLinkedCalendarsCount = mutatorAction(
    'setSelectedLinkedCalendarsCountMutator',
    (isSelected: boolean, forceReset?: boolean) => {
        let selectedLinkedCalendars = getStore().numberOfLinkedCalendarsSelected;

        if (forceReset) {
            getStore().numberOfLinkedCalendarsSelected = isSelected ? 1 : 0;
        } else {
            getStore().numberOfLinkedCalendarsSelected = isSelected
                ? ++selectedLinkedCalendars
                : --selectedLinkedCalendars;
        }
    }
);
